Shopify.actionTab = function(){
    const tabs = document.querySelectorAll('[data-bid]');
    const tabInfos = document.querySelectorAll('.tab_se_element');
    if(!tabs && tabs.length < 1){return}
    tabs.forEach(tab => {
      tab.addEventListener('click', function(e) {
        e.preventDefault();
        let myTabId = tab && tab.getAttribute('data-bid');
        const target = document.getElementById(myTabId);
        
        tabs.forEach(deactive => {
          deactive.classList.remove('tt_active');
        });
        tab.classList.add('tt_active');
  
        tabInfos.forEach(tabInfo => {
          tabInfo.classList.remove('ct_active');
        })
        target.classList.add('ct_active');
      })
    })
  }
  Shopify.actionTab();